"use client";
import { ThemeProvider } from "next-themes";
import { ToastContainer } from "react-toastify";

export default function Providers({ children }) {
  return (
    <ThemeProvider defaultTheme="dark" attribute="class">
      {children}
      <ToastContainer />
    </ThemeProvider>
  );
}
